import _ from 'lodash';
import { _dataLinksCollectionName } from '../../../../projectSpecific/sports/dbActions/globals';
import { dispatchProps } from '../../../cnr/reducers/reducerHelpers/dispatchProps';
import { sortingHelpers } from '../../../common/sorting';
import { createRefPath_event } from '../../appData/appRefPaths';
import { dataFix } from 'global/common/dataFix';
import { ammendAllDates, dateHelpers } from 'global/common/dateFormatting';
import { createStaticViewFromDataCollections } from 'global/common/convert';
import { deleteField } from 'firebase/firestore';

const _allowLinkUpdates = false

export const updateLinkHelpers = {
  ammendAppDataLinks: (data, aps_viewItems) => ammendAppDataLinks(data, aps_viewItems),
  autoSyncBidirectional: (data) => autoSyncBidirectional(data),
  createAppLinks: (pathViews, documentsData, callback) => createAppLinks(pathViews, documentsData, callback),
  createDocLinks: (pathViews, appLinks, callback) => createDocLinks(pathViews, appLinks, callback),
  enforceBidirectionalLinks: (appDocuments, applyChanges, updatesOnly) => enforceBidirectionalLinks(appDocuments, applyChanges, updatesOnly),
  get_appLinkedData: (pathViews, appDataKey, appData, appDataKeys, allowUpdate) => get_appLinkedData(pathViews, appDataKey, appData, appDataKeys, allowUpdate),
  get_linkedData: (currentList, dataLinkProps, appDataLinks) => getLinkedData(currentList, dataLinkProps, appDataLinks),
  getDocsToUpdate: ({ vit, prevItem, nextItem, appDatas }) => syncImplicitRelationships({ vit, prevItem, nextItem, appDatas }),
  update_appLinkedData: (pathViews, _linkedData, dispatch) => update_appLinkedData(pathViews, _linkedData, dispatch),
}

export const syncImplicitRelationships = ({
  vit,
  prevItem = {},
  nextItem = {},
  appDatas
}) => {
  const sourceKey = nextItem._itemKey;
  const updates = {};

  _.forEach(nextItem, (nextPropValue, nextPropKey) => {

    // Only array props imply relationships
    if (!Array.isArray(nextPropValue)) return;

    // If there is no matching collection, ignore
    const relatedAppData = appDatas[nextPropKey];
    if (!relatedAppData) return;

    const prevArray = Array.isArray(prevItem[nextPropKey])
      ? prevItem[nextPropKey]
      : [];

    // If the array did not change → skip
    if (_.isEqual(prevArray, nextPropValue)) return;

    // All related docs that might be affected
    const affectedKeys = _.union(prevArray, nextPropValue);
    console.log('affectedKeys', affectedKeys)

    _.forEach(affectedKeys, (relKey) => {
      const existing = _.get(relatedAppData, [relKey, vit], []);
      const shouldInclude = nextPropValue.includes(relKey);

      const nextRelated = shouldInclude
        ? _.uniq([...existing, sourceKey])
        : _.without(existing, sourceKey);

      if (!updates[nextPropKey]) {
        updates[nextPropKey] = {};
      }

      updates[nextPropKey][relKey] = {
        [vit]: nextRelated.length > 0 ? nextRelated : deleteField()
      };

      // _.set(
      //   updates,
      //   [nextPropKey, relKey],
      //   {
      //     [vit]: nextRelated.length > 0 ? nextRelated : deleteField()
      //   }
      // );
    });
  });

  return updates;
};

const ammendAppDataLinks = (appDataDocuments, aps_viewItems) => {
  const _updatedCollections = enforceBidirectionalLinks(appDataDocuments, false)
  const _appDataLinks = createAppLinks(null, appDataDocuments)
  delete appDataDocuments.staticViews
  const svs = createStaticViewFromDataCollections(appDataDocuments, aps_viewItems)
  ammendAllDates(appDataDocuments)
  return { svs, _appDataLinks }
}

function autoSyncBidirectional_xxx(data) {

  const collectionKeys = _.keys(data);

  console.log('data', data)

  //
  // STEP 0 — Ensure all collections are objects
  //
  _.forEach(collectionKeys, (type) => {
    if (!_.isPlainObject(data[type])) data[type] = {};
  });

  //
  // STEP 1 — Detect all implicit collection-to-collection relationship fields
  //
  const relationshipMap = {};
  // structure: { sessions: ['locations', 'attendees'], ... }

  _.forEach(collectionKeys, (collectionKey) => {
    relationshipMap[collectionKey] = [];

    _.forEach(data[collectionKey], (dataItem) => {
      _.forOwn(dataItem, (dataValue, dataPropKey) => {
        if (_.includes(collectionKeys, dataPropKey)) {
          relationshipMap[collectionKey].push(dataPropKey);
        }
      });
    });

    relationshipMap[collectionKey] = _.uniq(relationshipMap[collectionKey]);
  });


  //
  // STEP 2 — STRING → ARRAY-OF-ID RESOLUTION
  //
  _.forEach(collectionKeys, (collectionKey) => {
    _.forEach(data[collectionKey], (dataItem) => {
      relationshipMap[collectionKey].forEach((relatedCollectionName) => {
        const val = dataItem[relatedCollectionName];
        if (_.isString(val)) {
          // Find related item by .name === val
          const matchKey = _.findKey(data[relatedCollectionName], (objB) => objB?.name === val);

          if (matchKey) {
            dataItem[relatedCollectionName] = [matchKey];
          } else {
            // No match — treat as empty relationship
            dataItem[relatedCollectionName] = [];
          }
        }
      });
    });
  });


  //
  // STEP 3 — Build staged changes to avoid cross-mutation
  //
  const stagedAdds = {};
  // stagedAdds[collection][key][field] = Set([...ids])

  const stageAdd = (type, key, field, idToAdd) => {
    if (!stagedAdds[type]) stagedAdds[type] = {};
    if (!stagedAdds[type][key]) stagedAdds[type][key] = {};
    if (!stagedAdds[type][key][field]) stagedAdds[type][key][field] = new Set();
    stagedAdds[type][key][field].add(idToAdd);
  };


  //
  // STEP 4 — FORWARD RELATIONSHIP SYNC (A → B)
  //
  _.forEach(collectionKeys, (collectionKeyA) => {
    _.forEach(relationshipMap, (relMap, relMapKey) => {

      // })
      // relationshipMap[collectionKeyA].forEach((typeB) => {
      _.forEach(data[collectionKeyA], (dataItemA, keyA) => {
        let ids = dataItemA[relMapKey];

        // No array? Convert to empty array
        if (!_.isArray(ids)) ids = dataItemA[relMapKey] = [];

        // Remove invalid IDs
        const validIds = ids.filter((id) => _.has(data[relMapKey], id));

        if (validIds.length !== ids.length) dataItemA[relMapKey] = validIds;

        // For each valid ID, stage reverse linking
        validIds.forEach((idB) => {
          stageAdd(relMapKey, idB, collectionKeyA, keyA);
        });
      });
    });
  });


  //
  // STEP 5 — APPLY STAGED CHANGES (Reverse linking B → A)
  //
  _.forEach(stagedAdds, (type, typeName) => {
    _.forEach(type, (fields, key) => {
      const obj = data[typeName][key];
      if (!obj) return;

      _.forEach(fields, (idsSet, fieldName) => {
        if (!_.isArray(obj[fieldName])) {
          obj[fieldName] = [];
        }
        const before = obj[fieldName].length;
        const merged = _.union(obj[fieldName], [...idsSet]);
        if (merged.length !== before) {
          obj[fieldName] = merged;
        }
      });
    });
  });


  //
  // STEP 6 — SORT arrays ONLY if needed
  //
  _.forEach(collectionKeys, (type) => {
    _.forEach(data[type], (obj) => {
      _.forOwn(obj, (val, key) => {
        if (_.isArray(val)) {
          const sorted = _.sortBy(val);
          if (!_.isEqual(sorted, val)) {
            obj[key] = sorted;
          }
        }
      });
    });
  });


  //
  // STEP 7 — CLEAN & FIX DATE FIELDS (existing helpers)
  //
  _.forEach(data, (d, dk) => {
    data[dk] = dataFix.cleanDocumentsData(d);
    data[dk] = dateHelpers.convertDatesInObject(data[dk]);
  });

  return data;
}


function autoSyncBidirectional(data, _dataCollectionKey) {

  const collectionKeys = _.keys(data);

  const _collectionDatas = {}

  // loop the collectionKeys
  _.forEach(collectionKeys, (collectionKey) => {
    // loop the data
    _.forEach(data, (dataCollection, dataCollectionKey) => {
      // loop the dataCollection
      _.forEach(dataCollection, (dataCollectionItem, dataCollectionItemKey) => {
        // does the dataCollectionItem contain an collectionKey prop
        if (dataCollectionItem[collectionKey]) {
          // set the relatedDataCollection
          const relatedDataCollection = data?.[collectionKey]
          if (relatedDataCollection) {
            if (!_collectionDatas[dataCollectionKey]) { _collectionDatas[dataCollectionKey] = {} }
            if (!_collectionDatas[dataCollectionKey][dataCollectionItemKey]) { _collectionDatas[dataCollectionKey][dataCollectionItemKey] = {} }
            if (!_collectionDatas[dataCollectionKey][dataCollectionItemKey][collectionKey]) { _collectionDatas[dataCollectionKey][dataCollectionItemKey][collectionKey] = [] }

          }
          const dataItemMatch = dataCollectionItem[collectionKey]
          // let dataItemMatch_value;
          if (_.isString(dataItemMatch)) {
            // if dataItemMatch is a string, find the key from 
            const relatedDataItem = _.find(relatedDataCollection, { name: dataItemMatch })
            if (relatedDataItem) {
              const { _itemKey } = relatedDataItem ?? {}
              _collectionDatas[dataCollectionKey][dataCollectionItemKey][collectionKey].push(_itemKey)
              // dataItemMatch_value = _itemKey
            }
          } else if (_.isArray(dataItemMatch)) {
            const _newArray = []
            _.forEach(dataItemMatch, (dimKey) => {
              if (_.size(dimKey) === 20) {
                _newArray.push(dimKey)

              } else {
                const relatedDataItemKey = _.findKey(relatedDataCollection, { _oldKey: dimKey })
                if (relatedDataItemKey) {
                  _newArray.push(relatedDataItemKey)
                }
              }
            })
            _collectionDatas[dataCollectionKey][dataCollectionItemKey][collectionKey] = _newArray
          }
        }
      })
    })
  })

  const _data = _.merge({}, data, _collectionDatas);

  _.forEach(_data, (d, dk) => {
    _data[dk] = dataFix.cleanDocumentsData(d)
    _data[dk] = dateHelpers.convertDatesInObject(_data[dk])
  })

  enforceBidirectionalLinks(_data, true)

  return _data;
}

function normalizeDocumentReferences(appDataDocuments) {

  const result = _.cloneDeep(appDataDocuments);

  Object.entries(result).forEach(([collectionKey, collectionData]) => {
    Object.values(collectionData).forEach(item => {
      Object.entries(item).forEach(([propKey, propValue]) => {
        if (Array.isArray(propValue)) {
          // If this propKey matches another document key
          if (appDataDocuments[propKey]) {
            const nameToKeyMap = Object.entries(appDataDocuments[propKey]).reduce((acc, [key, val]) => {
              acc[val.name] = key;
              return acc;
            }, {});

            // Replace names with corresponding keys
            item[propKey] = propValue.map(name => nameToKeyMap[name] || name);
          }
        }
      });
    });
  });


  return result;
}

function enforceBidirectionalLinks(appDocuments, applyChanges = false, updatesOnly = false) {

  const _updatedCollections = {};

  const appDocumentKeys = _.keys(appDocuments);

  _.forEach(appDocumentKeys, (documentKey) => {
    const appDocument = appDocuments[documentKey];

    _.forEach(appDocument, (appDoc, appDocKey) => {
      _.forOwn(appDoc, (value, fieldKey) => {
        if (_.isArray(value) && appDocumentKeys.includes(fieldKey)) {
          const targetType = fieldKey;
          const relatedDocs = appDocuments[targetType];

          _.forEach(value, (targetKey) => {
            const relatedDocItem = relatedDocs?.[targetKey];
            if (!relatedDocItem) return;

            // Initialize relatedDocItem[documentKey] if needed
            if (!Array.isArray(relatedDocItem[documentKey])) {
              relatedDocItem[documentKey] = [];
            }

            // If the backlink doesn't exist yet, add it
            if (!relatedDocItem[documentKey].includes(appDocKey)) {
              const updatedArray = [...relatedDocItem[documentKey], appDocKey];

              if (applyChanges) {
                relatedDocItem[documentKey] = updatedArray;
              }

              if (updatesOnly) {
                if (!_updatedCollections[targetType]) _updatedCollections[targetType] = {};
                if (!_updatedCollections[targetType][targetKey]) _updatedCollections[targetType][targetKey] = {};

                const existing = _updatedCollections[targetType][targetKey][documentKey] || [];
                const merged = _.uniq([...existing, appDocKey]);
                _updatedCollections[targetType][targetKey][documentKey] = merged;

              } else {
                if (!_updatedCollections[targetType]) _updatedCollections[targetType] = {};

                const existing = _updatedCollections[targetType][targetKey] || _.cloneDeep(relatedDocItem);
                existing[documentKey] = _.uniq([...(existing[documentKey] || []), appDocKey]);
                _updatedCollections[targetType][targetKey] = existing;
              }

              // if (updatesOnly) {
              //   const existing = _.get(_updatedCollections, [targetType, targetKey, documentKey], []);
              //   const merged = _.uniq([...existing, appDocKey]);
              //   _.set(_updatedCollections, [targetType, targetKey, documentKey], merged);
              // } else {
              //   const existing = _.get(_updatedCollections, [targetType, targetKey], _.cloneDeep(relatedDocItem));
              //   existing[documentKey] = _.uniq([...(existing[documentKey] || []), appDocKey]);
              //   _.set(_updatedCollections, [targetType, targetKey], existing);
              // }
            }
          });
        }
      });
    });
  });

  return _updatedCollections;
}


function enforceBidirectionalLinksXXX(appDocuments, applyChanges = false) {

  const _updatedCollections = {};

  const appDocumentKeys = _.keys(appDocuments);

  _.forEach(appDocumentKeys, (documentKey) => {
    const appDocument = appDocuments[documentKey];

    _.forEach(appDocument, (appDoc, appDocKey) => {
      _.forOwn(appDoc, (value, fieldKey) => {
        if (_.isArray(value) && appDocumentKeys.includes(fieldKey)) {
          const targetType = fieldKey;
          const relatedDocs = appDocuments[targetType];

          _.forEach(value, (targetKey) => {
            const relatedDocItem = relatedDocs?.[targetKey];
            if (!relatedDocItem) return;

            relatedDocItem[documentKey] = relatedDocItem[documentKey] || [];

            if (!relatedDocItem[documentKey].includes(appDocKey)) {
              if (applyChanges) {
                relatedDocItem[documentKey].push(appDocKey);
              }
              _.set(_updatedCollections, [targetType, targetKey], appDocuments[targetType][targetKey]);
            }
          });
        }
      });
    });
  });

  return _updatedCollections;
}


const createDocLinks = (pathViews, documentsData, callback) => {
  const appDataLinks = {}
  const _appDataKeys = _.keys(documentsData)
  _.forEach(documentsData, (appData, appDataKey) => {
    const linkData = get_appLinkedData(pathViews, appDataKey, appData, _appDataKeys)
    if (!_.isEmpty(linkData)) {
      appDataLinks[appDataKey] = linkData[appDataKey]
    }
  })
  if (callback) {
    callback(appDataLinks)
  } else {
    return appDataLinks
  }
}

const createAppLinks = (pathViews, documentsData, callback) => {
  const appDataLinks = {}
  const _appDataKeys = _.keys(documentsData)
  _.forEach(documentsData, (appData, appDataKey) => {
    const linkData = get_appLinkedData(pathViews, appDataKey, appData, _appDataKeys)
    if (!_.isEmpty(linkData)) {
      appDataLinks[appDataKey] = linkData[appDataKey]
    }
  })
  if (callback) {
    callback(appDataLinks)
  } else {
    return appDataLinks
  }
}

const update_appLinkedData = (pathViews, _linkedData, dispatch) => {
  _.forEach(_linkedData, (data, key) => {
    const _refPathL = createRefPath_event(pathViews, [_dataLinksCollectionName, key])
    if (_allowLinkUpdates) {
      database_fns.set_doc(_refPathL, data, true).then(res => {
        dispatch && dispatch({ type: dispatchProps.successAlt, dispatch })
      }).catch(error => {
        console.log('error', error)
      })
    } else {
      console.log('update_appLinkedData', _refPathL, data)
    }
  })
}

const get_appLinkedData = (pathViews, appDataKey, appData, appDataKeys, allowUpdate) => {
  const _linkedData = {}
  if (appData) {
    _.forEach(appData, (dataItem, docKey) => { // docKey = attendees, sessions, etc. 
      _.forEach(dataItem, (docPropValue, docProp) => { // docProp = name, attendees, sessions, etc.
        // if the docPropValue is an array AND the docProp is a key in the appDataDocuments
        if (appDataKeys.includes(docProp) && _.isArray(docPropValue) && _.size(docPropValue) > 0) {
          // create the OBEJCT if needed
          if (!_linkedData[appDataKey]) { _linkedData[appDataKey] = {} }
          if (!_linkedData[appDataKey][docKey]) { _linkedData[appDataKey][docKey] = {} }
          if (!_linkedData[appDataKey][docKey][docProp]) { _linkedData[appDataKey][docKey][docProp] = {} }
          _linkedData[appDataKey][docKey][docProp] = docPropValue
        }
      })
    })
  }

  if (allowUpdate && !_.isEmpty(_linkedData)) {
    update_appLinkedData(pathViews, _linkedData)
  }
  return _linkedData

}

const getLinkedData = (currentList, dataLinkProps, appDataLinks) => {

  const selectedKeyed = _(currentList)
    .filter({ _selected: true })
    .keyBy('_itemKey')
    .value();

  const _newArray = _.keys(selectedKeyed)
  const _linkedData = {
    [dataLinkProps.parentCollection]: {
      [dataLinkProps.parentCollectionKey]: {
        [dataLinkProps.linkCollection]: _newArray
      }
    }
  }
  const _linkedDataInverse = getInversedLinks(currentList, appDataLinks, dataLinkProps)
  const _linkDataCombined = { ..._linkedData, ..._linkedDataInverse }
  return { _newArray, _linkedData, _linkedDataInverse, _linkDataCombined }
}

const getInversedLinks = (currentList, appDataLinks, dataLinkProps) => {

  // currentList = sessions
  // sessions
  const appDataLink = appDataLinks[dataLinkProps.linkCollection]

  // console.log('inverseLink', appDataLink)
  // console.log('currentList', currentList)
  // console.log('dataLinkProps', dataLinkProps)

  const linkedInverse = {}

  const _clc = _.pickBy(currentList, { _changed: true })
  // console.log('_clc', _clc)

  // sessions
  _.forEach(_clc, (selectedItem, selectedItemKey) => {

    // is the session selected?
    const { _selected } = selectedItem ?? {}

    const appDataLinkItem = appDataLink[selectedItemKey]

    let parentArray = appDataLinkItem?.[dataLinkProps.parentCollection] // attendees

    if (!parentArray) {
      parentArray = []
    }

    // is is selected?
    if (_selected) {
      if (!parentArray.includes(dataLinkProps.parentCollectionKey)) {
        parentArray.push(dataLinkProps.parentCollectionKey)
      }
    } else {
      if (parentArray.includes(dataLinkProps.parentCollectionKey)) {
        sortingHelpers.removeArrayItem(parentArray, dataLinkProps.parentCollectionKey)
      }
    }

    linkedInverse[selectedItemKey] = {
      [dataLinkProps.parentCollection]: parentArray
    }
  })

  const dtu = {
    [dataLinkProps.linkCollection]: linkedInverse
  }

  return dtu

}